import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setReasonForEncounterOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getReasonForEncounterOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getReasonForEncounterOptions])
    const { entity } = response
    yield put(setReasonForEncounterOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getReasonForEncounterOptions() error: ${e}`))
  }
}

export function* getReasonForEncounterOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getReasonForEncounterOptions)
}
